export default __webpack_public_path__ + "static/media/Wings of Salvation.335fb911.jpg";